import { PouchOperationsService, ShipmentsService } from '@/backend/market'
import { PouchOperationRepository } from '../../domain/repositories/PouchOperationRepository'
import { DriverPouchOperationModel } from '../models/DriverPouchOperationModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { DriverPouchOperationEntity } from '../../domain/entities/DriverPouchOperationEntity'
import type { AccountantPouchOperationEntity } from '../../domain/entities/AccountantPouchOperationEntity'
import { AccountantPouchOperationModel } from '../models/AccountantPouchOperationModel'
import type { PouchOperationFilterEntity } from '../../domain/entities/PouchOperationFilterEntity'
import { PouchOperationFilterModel } from '../models/DriverPouchOperationFilterModel'
import type { DriverRoundDifferencePouchOperationFilterEntity } from '../../domain/entities/DriverRoundDifferencePouchOperationFilterEntity'
import { DriverRoundDifferencePouchOperationFilterModel } from '../models/DriverRoundDifferencePouchOperationFilterModel'
import { DriverRoundDifferencePouchOperationModel } from '../models/DriverRoundDifferencePouchOperationModel'
import type { DriverRoundDifferencePouchOperationEntity } from '../../domain/entities/DriverRoundDifferencePouchOperationEntity'

export class PouchOperationRepositoryImpl implements PouchOperationRepository {
  async getDriverPouchOperations(
    filterData: PouchOperationFilterEntity
  ): Promise<PaginateEntity<DriverPouchOperationEntity[]> | { error: true }> {
    const filterModel = new PouchOperationFilterModel(filterData)
    try {
      const response = await PouchOperationsService.getDriverPouchOperationsAdmin(filterModel)
      const driverModels = response.items?.map((item) => new DriverPouchOperationModel(item))
      const activityLogResponse = new PaginateEntity<DriverPouchOperationModel[]>(
        response,
        driverModels
      )
      return activityLogResponse
    } catch {
      return { error: true }
    }
  }
  async getDriverRoundDifferencePouchOperations(
    filterData: DriverRoundDifferencePouchOperationFilterEntity
  ): Promise<PaginateEntity<DriverRoundDifferencePouchOperationEntity[]> | { error: true }> {
    const filterModel = new DriverRoundDifferencePouchOperationFilterModel(filterData)
    try {
      const response =
        await PouchOperationsService.getDriverRoundDifferencePouchOperationsAdmin(filterModel)
      const driverModels = response.items?.map(
        (item) => new DriverRoundDifferencePouchOperationModel(item)
      )
      const activityLogResponse = new PaginateEntity<DriverRoundDifferencePouchOperationModel[]>(
        response,
        driverModels
      )
      return activityLogResponse
    } catch {
      return { error: true }
    }
  }
  async getAccountantPouchOperation(
    filterData: PouchOperationFilterEntity
  ): Promise<PaginateEntity<AccountantPouchOperationEntity[]> | { error: true }> {
    const filterModel = new PouchOperationFilterModel(filterData)
    try {
      const response = await PouchOperationsService.getAccountantPouchOperationsAdmin(filterModel)
      const driverModels = response.items?.map((item) => new AccountantPouchOperationModel(item))
      const activityLogResponse = new PaginateEntity<AccountantPouchOperationModel[]>(
        response,
        driverModels
      )
      return activityLogResponse
    } catch {
      return { error: true }
    }
  }
  async updatePouchOperation({
    pouchId,
    amount,
    description,
    dateTime
  }: {
    pouchId: number
    amount: number
    description?: string
    dateTime?: string
  }): Promise<{ success: true } | { error: true }> {
    try {
      await PouchOperationsService.postPouchOperationAdmin({
        amount,
        pouchId,
        description,
        dateTime
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async transferPouch({
    pouchId,
    amount,
    description,
    dateTime
  }: {
    pouchId: number
    amount: number
    description?: string
    dateTime?: string
  }): Promise<{ success: true } | { error: true }> {
    try {
      await PouchOperationsService.postPouchOperationSelfTransferAdmin({
        amount,
        pouchId,
        description,
        dateTime
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updatePouchOperationShipment(
    shipmentId: string
  ): Promise<{ success: true } | { error: true }> {
    try {
      await ShipmentsService.postSyncPouchOperationForShipmentAdmin({
        id: shipmentId
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
